import DashboardPage from './DashboardPage'
import { appMenu } from './sideBarOption'

export { appMenu }
export default DashboardPage
